import React from "react";

function BlueButton({ children, onClick, size, type, disabled }) {
  let btnH;

  switch (size) {
    case "small":
      btnH = "h-12";
      break;
    case "large":
      btnH = "h-24";
      break;
    default:
      btnH = "h-12";
  }

  return (
    <button
      className={`retro-border-normal bg-retro-blue ${btnH} w-full p-[2px] ${
        disabled ? "cursor-not-allowed" : "cursor-pointer"
      } uppercase font-retro-rounded font-medium text-lg xl:text-xl w-full px-4 flex justify-center items-center leading-none`}
      onClick={onClick}
      type={type}
      disabled={disabled}
    >
      {children}
    </button>
  );
}

function YellowButton({ children, onClick, size, type, disabled }) {
  let btnH;

  switch (size) {
    case "small":
      btnH = "h-12";
      break;
    case "large":
      btnH = "h-24";
      break;
    default:
      btnH = "h-12";
  }

  return (
    <button
      className={`retro-border-normal bg-retro-yellow ${btnH} w-full p-[2px] ${
        disabled ? "cursor-not-allowed" : "cursor-pointer"
      } uppercase font-retro-rounded font-medium text-lg xl:text-xl w-full px-4 flex justify-center items-center leading-none`}
      onClick={onClick}
      type={type}
      disabled={disabled}
    >
      {children}
    </button>
  );
}

function OrangeButton({ children, onClick, size, type, disabled }) {
  let btnH;

  switch (size) {
    case "small":
      btnH = "h-12";
      break;
    case "large":
      btnH = "h-24";
      break;
    default:
      btnH = "h-12";
  }

  return (
    <button
      className={`retro-border-normal bg-retro-orange ${btnH} w-full p-[2px] ${
        disabled ? "cursor-not-allowed" : "cursor-pointer"
      } uppercase font-retro-rounded font-medium text-lg xl:text-xl w-full px-4 flex justify-center items-center leading-none`}
      onClick={onClick}
      type={type}
      disabled={disabled}
    >
      {children}
    </button>
  );
}

function AqmarineButton({ children, onClick, size, type, disabled }) {
  let btnH;

  switch (size) {
    case "small":
      btnH = "h-12";
      break;
    case "large":
      btnH = "h-24";
      break;
    default:
      btnH = "h-12";
  }

  return (
    <button
      className={`retro-border-normal bg-retro-aqmarine ${btnH} w-full p-[2px] ${
        disabled ? "cursor-not-allowed" : "cursor-pointer"
      } uppercase font-retro-rounded font-medium text-lg xl:text-xl w-full px-4 flex justify-center items-center leading-none`}
      onClick={onClick}
      type={type}
      disabled={disabled}
    >
      {children}
    </button>
  );
}

function BlackButton({ children, onClick, size, type, disabled }) {
  let btnH;

  switch (size) {
    case "small":
      btnH = "h-12";
      break;
    case "large":
      btnH = "h-24";
      break;
    default:
      btnH = "h-12";
  }

  return (
    <button
      className={`retro-border-normal bg-black ${btnH} w-full p-[2px] ${
        disabled ? "cursor-not-allowed" : "cursor-pointer"
      } uppercase font-retro-rounded font-medium text-white text-lg xl:text-xl w-full px-4 flex justify-center items-center leading-none`}
      onClick={onClick}
      type={type}
      disabled={disabled}
    >
      {children}
    </button>
  );
}

export { BlueButton, YellowButton, OrangeButton, AqmarineButton, BlackButton };
